import React, { useCallback } from 'react';
import type {
  AfcSubmission,
  AfcSubmissionCandidateOpportunity,
  Candidate,
  CandidateLegalTechSkill,
  GroupedExperiences,
  Taxonomy,
} from '@axiom/validation';

import { Grid } from '../../layout/Grid/Grid';
import { GridRow } from '../../layout/Grid/GridRow';
import { GridColumn } from '../../layout/Grid/GridColumn';
import { Gutter } from '../../layout/Gutter/Gutter';
import { BioPdfCandidate } from '../BioPdf/BioPdfCandidate';
import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { SubmissionPdfDescriptionSingleTalent } from '../SubmissionPdfDescriptionSingleTalent/SubmissionPdfDescriptionSingleTalent';

export type SplitSubmissionPdfTypes = {
  isDownloading?: boolean;
  submission: AfcSubmission;
  candidateOpp: AfcSubmissionCandidateOpportunity;
  allGroupedExperiences: GroupedExperiences[][];
  clientUrl: string;
  loginUrl: string;
  taxonomy: Taxonomy;
  allCandidateIds: string[];
  allLegalTechnicalSkills: CandidateLegalTechSkill[][];
};

export const SplitSubmissionPdf = ({
  isDownloading,
  submission,
  candidateOpp,
  allGroupedExperiences,
  loginUrl,
  taxonomy,
  allCandidateIds,
  allLegalTechnicalSkills,
}: SplitSubmissionPdfTypes) => {
  const getExperiences = useCallback(
    (id: Candidate['id']): GroupedExperiences[] => {
      return allGroupedExperiences.find(ge => ge[0]?.candidateId === id) || [];
    },
    [allGroupedExperiences, candidateOpp]
  );
  const getLegalTechnicalSkills = useCallback(
    (id: Candidate['id']): CandidateLegalTechSkill[] => {
      const index = allCandidateIds.indexOf(id);
      return allLegalTechnicalSkills[index] || [];
    },
    [allLegalTechnicalSkills, candidateOpp]
  );

  return (
    <div className="k-pdf-export">
      <Layout
        background="panelLight"
        name="SUBMISSION_PDF"
        direction="vertical"
      >
        <LayoutItem>
          <Grid>
            <GridRow>
              <GridColumn>
                <Gutter bottom="32px" key={candidateOpp.candidate.id}>
                  <BioPdfCandidate
                    isDownloading={isDownloading}
                    candidate={candidateOpp.candidate}
                    submissionDescription={candidateOpp.submissionDescription}
                    groupedExperiences={getExperiences(
                      candidateOpp.candidate.id
                    )}
                    showCandidateReputation={
                      candidateOpp.showCandidateReputation
                    }
                    candidateReputationClarification={
                      candidateOpp.candidateReputationClarification
                    }
                    submission={submission}
                    taxonomy={taxonomy}
                    removeLogo
                    legalTechSkills={getLegalTechnicalSkills(
                      candidateOpp.candidate.id
                    )}
                  />
                </Gutter>
              </GridColumn>
            </GridRow>
          </Grid>
        </LayoutItem>
        <LayoutItem>
          <SubmissionPdfDescriptionSingleTalent
            loginUrl={loginUrl}
            candidate={candidateOpp.candidate}
            submission={submission}
          />
        </LayoutItem>
      </Layout>
    </div>
  );
};
